import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { getGameSortJson } from '@/views/system/lookingSuit/server';

export interface HomeSuitsState {
  isWorldLegend: boolean;
  list: getGameSortJson[];
  clientTime: number;
  navTabbtnId: number;
}

const HOMESUIT_KEY = 'React-ts-ant-homeSuit';

const localHomeSuits = LocalStore.getValue<HomeSuitsState>(HOMESUIT_KEY) || {};

export const defaults: HomeSuitsState = {
  isWorldLegend: false,
  clientTime: 0,
  list: [],
  navTabbtnId: 1,
  ...localHomeSuits
};

const HOME_SUIT_KEY = 'React-ts-ant-HOMESUITS';

export const updateHomeSuits: (homeSuits: HomeSuitsState) => IAction<HomeSuitsState> = (homeSuits: HomeSuitsState) => ({
  type: HOME_SUIT_KEY,
  payload: homeSuits
});

const homeSuitReducer: Reducer<HomeSuitsState, IAction<any>> = (state = defaults, action: IAction<any>) => {
  const { type, payload } = action;

  switch (type) {
    case HOME_SUIT_KEY:
      LocalStore.setValue(HOMESUIT_KEY, payload as HomeSuitsState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default homeSuitReducer;
